/**
 * AppointmentsTab — Tab 6 of the patient-edit shell (PROD-734, PR A).
 *
 * Flutter ref: `create_patient_screen.dart:1208` (`case 5:`) →
 * `PatientAppointmentsTab`. Mounts a paginated list of this patient's
 * appointments (`POST /api/Appointment/ByPatientId`).
 *
 * PR A: read-only list (Date / Time / Doctor / Room / RFV / Status / Note).
 * Filter widgets → PR B. Row actions (View / Reschedule / Cancel) → PR C.
 */

import { PatientAppointmentsTabBody } from '@/patients/components/appointments/patient-appointments-tab-body';
import type { Patient } from '@/types/patient-api';

export interface AppointmentsTabProps {
  patient: Patient | null;
}

export function AppointmentsTab({ patient }: AppointmentsTabProps) {
  return <PatientAppointmentsTabBody patientId={patient?.patientId ?? null} />;
}
